var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairJoysticks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.92,40.81h-9.79l-2.73-12.96c2.69-1.61,4.49-4.55,4.49-7.9,0-5.08-4.14-9.22-9.22-9.22s-9.22,4.14-9.22,9.22c0,3.36,1.81,6.29,4.49,7.9l-2.73,12.96H14.56c-2.6,0-4.72,2.12-4.72,4.72v9.83c0,.83,.67,1.5,1.5,1.5H52.14c.83,0,1.5-.67,1.5-1.5v-9.83c0-2.6-2.12-4.72-4.72-4.72ZM31.68,13.72c3.43,0,6.22,2.79,6.22,6.22s-2.79,6.22-6.22,6.22-6.22-2.79-6.22-6.22,2.79-6.22,6.22-6.22Zm1.94,15.44l2.45,11.64h-8.78l2.45-11.64h3.88Zm17.03,24.7H12.84v-8.33c0-.95,.77-1.72,1.72-1.72H48.92c.95,0,1.72,.77,1.72,1.72v8.33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairJoysticks);
export default __webpack_public_path__ + "static/media/wheelchair_joysticks.645da617.svg";
export { ForwardRef as ReactComponent };